import DescriptionView from "components/DescriptionView";
import { FC } from "react";
import { Evidence } from "types";
import { DateView } from "utils/helper";

type Props = {
  evidence: Evidence | undefined;
  isOpen: boolean;
  onClose: () => void;
};

const EvidenceDetail: FC<Props> = ({ evidence, isOpen, onClose }) => {
  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="relative w-full max-w-2xl bg-white p-8 shadow-lg rounded-lg overflow-y-auto">
        <div className="text-base font-semibold text-white bg-[#212121] p-3 inline-block rounded-md">
          Evidence ID &nbsp;&nbsp; : &nbsp;&nbsp;
          {/* {evidence?.evidence_type} */}
        </div>

        <br />
        <div className="my-6 text-[22px] font-semibold leading-7">
          Evidence File
        </div>

        {[
          {
            property: "Investigation",
            value: evidence?.CR_number || "",
          },
          {
            property: "Incident Registration Number",
            value: evidence?.Incident_Registration_number || "",
          },
          { property: "Evidence Type", value: evidence?.evidence_type },
          {
            property: "Date Collected",
            value: DateView(evidence?.date_collected),
          },
        ]?.map((info, index) => (
          <div
            key={index}
            className="flex flex-row gap-4 mt-3 items-start justify-between border-b border-b-[#E9E9E9] pb-3"
          >
            <p className="font-normal text-base text-[#0A1D39]">
              {info?.property}
            </p>
            <p className="font-normal text-base text-[#0A1D39]">
              {typeof info?.value === "boolean" ||
              typeof info?.value === "object"
                ? info?.value ?? "-"
                : info?.value}
            </p>
          </div>
        ))}

        <div className="mt:2">
          <DescriptionView label="Description" value={evidence?.description} />
        </div>
      </div>
    </div>
  );
};

export default EvidenceDetail;
